import { Theme, useMediaQuery } from "@mui/material";
import { Fragment } from "react";
import {
    TextField,
    DatagridConfigurable,
    List,
    SearchInput,
    useListContext,
    TopToolbar,
    FilterButton,
    SortButton,
    useGetResourceLabel,
    DateInput,
    SelectColumnsButton,
    ReferenceInput,
    SelectInput
} from "react-admin";
import MobileGrid from "./MobileGrid";
import { defaultSacopExporter, standardSacopExporter, masterOfSharesExporter } from "../../../../shared/utilities/sacopExporter";
import SacopExportButton from "../../../../shared/components/core/SacopExportButton";

const ListActions = () => (
    <TopToolbar>
        <SortButton fields={['dateRequestAction']} />
        <FilterButton />
        <SelectColumnsButton />
        <SacopExportButton exporter={masterOfSharesExporter} />
    </TopToolbar>
);

const sectorFilters = [
    <SearchInput source="q" alwaysOn />,
    <DateInput source="dateRequestAction" />,
    <ReferenceInput source="regulationId" reference="regulation" label="Filtrar por Regulación">
        <SelectInput optionText="regulationName" />
    </ReferenceInput>
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    // const { filterValues, setFilters, displayedFilters } = listContext;
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );

    return (
        <Fragment>
            {(!isXSmall ? (
                <MobileGrid  {...listContext} />
            ) : (
                <DatagridConfigurable rowClick="edit" >
                    <TextField source="dateRequestAction" />
                </DatagridConfigurable>)
            )
            }
        </Fragment>
    );
}

const MasterOfSharesList = () => {
    const getResourceLabel = useGetResourceLabel();
    return (<List
        // filterDefaultValues={ { active: true }}
        sort={{ field: 'dateRequestAction', order: 'DESC' }}
        perPage={25}
        filters={sectorFilters}
        actions={<ListActions />}
        exporter={masterOfSharesExporter}
    >
        <TabbedDatagrid />
    </List>);
};

export default MasterOfSharesList;

